import 'intersection-observer'
import * as React from 'react'
import { IOWidget, Updater, fromJSX } from 'widgets-for-react'
import { ImageSize } from '../../../../cms/blocks/types.gen'
import { parseImageUrl } from '../../../../drupal/rendering/image_utils.mod'
import { ParsedMediaImage } from '../../../../drupal/types_and_parser/types'
import { CMSState } from '../../../drupalPage/state'

export type timelineBlockProps = {
  blockIndex: number
  title: string
  introduction: string
  items: Immutable.List<timelineItem>
}

export type timelineItem = {
  title: string
  introduction: string
  media: ParsedMediaImage
  field_image?: ParsedMediaImage
  image?: number
  image_alt?: string
  image_size?: ImageSize
}

export type timelineBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  quote_classname: string
  footer_classname: string
  author_classname: string
  clickable_classname: string
  visual_classname: string
  image_classname: string
}>

export function timelineBlock(
  props: timelineBlockProps,
  options?: { style: timelineBlockStyle; key?: string }
): IOWidget<CMSState, Updater<CMSState>> {
  return (s: CMSState) =>
    fromJSX((_) => {
      return (
        <section className="block block--timeline">
          <div className="block__inner container container--m grid--block">
            {props.title || props.introduction ? (
              <header className="block__header container container--m">
                {props.title && <h2 className="block__title title--l">{props.title}</h2>}
                {props.introduction && (
                  <div className="block__intro" dangerouslySetInnerHTML={{ __html: props.introduction }} />
                )}
              </header>
            ) : (
              <></>
            )}
            <div className="block__content">
              <ul className="block__list">
                {props.items
                  .map((item) => (
                    <>
                      {item.image ? (
                        <li className="block__item block__item--has-visual">
                          <div className="item__content">
                            <div className="item__visual">
                              <img
                                className="item__image lazyload"
                                alt={item.image_alt}
                                width="600"
                                height="600"
                                src="/images/empty.png"
                                data-src={`${parseImageUrl(
                                  item.field_image?.field_media_image?.image?.style_urls['600x600']
                                )}`}
                                data-srcset={`${parseImageUrl(
                                  item.field_image?.field_media_image?.image?.style_urls['450x450']
                                )} 450x450, ${parseImageUrl(
                                  item.field_image?.field_media_image?.image?.style_urls['600x600']
                                )} 600x600, ${parseImageUrl(
                                  item.field_image?.field_media_image?.image?.style_urls['1200x1200']
                                )}`}
                                data-sizes="auto"
                              />
                            </div>
                            <div className="item__message">
                              <h3 className="item__title title--m">{item.title}</h3>
                              <div className="item__intro">{item.introduction}</div>
                            </div>
                          </div>
                        </li>
                      ) : item.media ? (
                        <li className="block__item">
                          <div className="item__content">
                            <div className="item__message">
                              <img
                                className="item__icon"
                                src={item.media.field_media_image.image.url}
                                alt={item.media.field_media_image.alt}
                              />
                              <h3 className="item__title title--m">{item.title}</h3>
                              <div className="item__intro">{item.introduction}</div>
                            </div>
                          </div>
                        </li>
                      ) : (
                        <li className="block__item">
                          <div className="item__content">
                            <div className="item__message">
                              <h3 className="item__title title--m">{item.title}</h3>
                              <div className="item__intro">{item.introduction}</div>
                            </div>
                          </div>
                        </li>
                      )}
                    </>
                  ))
                  .toArray()}
              </ul>
            </div>
          </div>
        </section>
      )
    })
}
